module.exports = __webpack_public_path__ + "static/media/consultants.4d402f2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/panel/consultants.png
// module id = 796
// module chunks = 23